import React from 'react';

import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';

import FormContainer from '../../../FormContainer';

import useContactForm from '../../../../../forms/lender/contact';
import LenderContactService from '../../../../../services/LenderContactService';
import { useUiContext } from '../../../../../context/UiContext';
import useUserRole from '../../../../../hooks/useUserRole';

export default function Contact({ lenderId }) {
  const navigate = useNavigate();
  const { resourceId: id } = useParams();

  const { showSuccessToast, showApiErrorToast } = useUiContext();

  const { isSuperAdmin } = useUserRole();

  const isEdit = !!id && id !== 'new';

  const { data: lenderContact, refetch } = useQuery({
    queryKey: ['lenderContact', id],
    queryFn: () => LenderContactService.getLenderContact(id),
    enabled: !!id && id !== 'new',
  });

  const { mutate: createLenderContact, isPending: isCreating } = useMutation({
    mutationFn: (formValues) =>
      LenderContactService.createLenderContact({
        ...formValues,
        lender_id: lenderId,
      }),
    onSuccess: (newContact) => {
      showSuccessToast('Contact created successfully');
      navigate(`/lenders/${lenderId}/contacts/${newContact.id}?tab=Contact`);
    },
    onError: (error) => {
      showApiErrorToast(error);
    },
  });

  const { mutate: updateLenderContact, isPending: isUpdating } = useMutation({
    mutationFn: (formValues) =>
      LenderContactService.updateLenderContact({
        contactId: id,
        formValues,
      }),
    onSuccess: () => {
      showSuccessToast('Contact updated successfully');
      refetch();
    },
    onError: (error) => {
      showApiErrorToast(error);
    },
  });

  const form = useContactForm(
    isEdit ? updateLenderContact : createLenderContact,
    lenderContact,
    isSuperAdmin
  );

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <FormContainer
        isSubmitting={isCreating || isUpdating}
        form={form}
        noBillComId
        readOnly={!isSuperAdmin}
      />
    </div>
  );
}
